import clsx from 'clsx';
import { ComponentPropsWithRef, FC } from 'react';
import { highlightedFeedActionContainer } from '@/components/highlighted-feed-wrapper/highlighted-feed-header.css';

export const HighlightedFeedHeader: FC<ComponentPropsWithRef<'div'>> = ({
  children,
  className,
  ...props
}) => (
  <div className={clsx(highlightedFeedActionContainer, className)} {...props}>
    {children}
  </div>
);
